export const formatNumber = (value, type = 0) => {
    if (!Number.isNaN(Number.parseFloat(value))) {
        if (Number.parseFloat(value) === 0) {
            return 0;
        }
        if (value === "N/A") {
            return ""
        } else {
            return Number.parseFloat(value).toLocaleString("de-DE", {
                minimumFractionDigits: type,
                maximumFractionDigits: type
            })
        }
    } else {
        return value;
    }
};
export const formatDateTime = (dateTime) => {
    if (dateTime) {
        let options = {
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit',
            hour12: false
        };
        const date = new Date(dateTime);
        return new Intl.DateTimeFormat('vi-VN', options).format(date)
    }
    return ""
}